// Constants
import { WIDTH, HEIGHT } from 'components/kit/waveform/constants'

import styles from './bars.css'

type BarProps = {
  positions: Array<number>
  duration: number
}

const Bars = ({ positions, duration }: BarProps): JSX.Element => {
  return (
    <>
      {positions.map((startTime, index) => {
        const x = (startTime / duration) * WIDTH
        return <line x1={x} y1={0} x2={x} y2={HEIGHT} className={styles.disabledBar} key={String(index)} />
      })}
    </>
  )
}

export default Bars
